// extracted by mini-css-extract-plugin
export var active = "Tooltip-module--active--d221d";
export var arrow = "Tooltip-module--arrow--00f42";
export var arrowBottom = "Tooltip-module--arrow-bottom--65dd4";
export var arrowTop = "Tooltip-module--arrow-top--14f42";
export var container = "Tooltip-module--container--b76d2";